import axios from "axios";

const contactClient = axios.create({
  baseURL: "https://apiadm.datavisiooh.com",
  timeout: 50000,
});

export const contact = ({
  name = null,
  email = null,
  company = null,
  whatsapp = null,
  message = null,
}) =>
  contactClient.post("/leads-site", {
    name,
    email,
    company,
    whatsapp,
    message,
  });
